import { apiFetch } from "./api";

interface StartCallParams {
	campaign_id: string;
	first_name: string;
	last_name: string;
	phone: string;
	country_code: string;
	email: string;
	message?: string;
	recaptcha_token?: string;
	attribution: Record<string, string>;
}

export const startCall = async (params: StartCallParams): Promise<any> => {
	const {
		campaign_id,
		first_name,
		last_name,
		phone,
		country_code,
		email,
		message,
		recaptcha_token,
		attribution,
	} = params;

	const body: Record<string, unknown> = {
		campaign_id,
		prospect_firstname: first_name,
		prospect_lastname: last_name,
		prospect_phone: phone,
		prospect_country_code: country_code,
		prospect_email: email,
		attribution,
	};

	if (message) {
		body.prospect_message = message;
	}

	if (recaptcha_token) {
		body.recaptcha_token = recaptcha_token;
	}

	return apiFetch("POST", "/voice/start_call", { json: body });
};
